import type { IAnswerItemThink } from '../../types/history';

/** agent 历史：不用 metadata.id，避免多条 switch_agent 共用 "0" */
export const resolveAgentHistoryThinkId = (
  metadata?: { think_id?: string; },
  data?: { think_id?: string; id?: string; },
): string => data?.think_id || data?.id || metadata?.think_id || '';

export const getNextSwitchAgentInputIndex = (thinkContainer: IAnswerItemThink): number => {
  let inputIndex = 1;
  if (!Array.isArray(thinkContainer.value)) {
    return inputIndex;
  }
  thinkContainer.value.forEach((thinkItem: { type?: string; }) => {
    if (thinkItem?.type === 'switch_agent') {
      inputIndex += 1;
    }
  });
  return inputIndex;
};

interface IAgentHistoryTextParams {
  thinkContainer: IAnswerItemThink;
  text: string;
  metadata?: { tool_call_id?: string; think_id?: string; };
}

/** agent 历史：text part 解析（无 tool_call_id → 正文，有 → text_tool） */
export const appendAgentHistoryTextPart = ({
  thinkContainer,
  text,
  metadata,
}: IAgentHistoryTextParams): 'think' | 'answer' => {
  if (metadata?.tool_call_id) {
    const thinkItem = {
      type: 'text_tool' as const,
      value: text,
      tool_call_id: metadata.tool_call_id,
      thinkId: resolveAgentHistoryThinkId(metadata),
    };
    const existing = thinkContainer.value?.find(
      (v: { type?: string; tool_call_id?: string; }) =>
        v?.type === 'text_tool' && v?.tool_call_id === metadata.tool_call_id,
    );
    if (existing) {
      // 不可变写法：创建新数组和新对象，避免 mutate 原始数据
      thinkContainer.value = thinkContainer.value.map((v: any) =>
        v === existing ? { ...v, value: (v.value || '') + text } : v,
      );
    } else {
      thinkContainer.value = [...(thinkContainer.value || []), thinkItem as never];
    }
    return 'think';
  }
  return 'answer';
};
